{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_SNAPSHOT_11052026-082025", "buildTime": "05/11/2026 08:20:25"}